module.exports = "/images/Ropes Course.svg?7de52b73c93d5fe7a3a9ffe25a417bb0";